import { render } from "./layanan.vue?vue&type=template&id=9a2e909e"
import script from "./layanan.vue?vue&type=script&lang=js"
export * from "./layanan.vue?vue&type=script&lang=js"

import "./layanan.vue?vue&type=style&index=0&id=9a2e909e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__